module.exports = __webpack_public_path__ + "a84aaf8bba58ac57f089d1864c40aec8.MP3";